import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useGetCecmasMutation, useGetSubMutation } from '../slices/usersApiSlice';
import { Card, Empty, notification, Spin } from 'antd';

const FreeRoute = () => {

const [api, contextHolder] = notification.useNotification();
const [getmySub, { isLoading: ismyLoading }] = useGetSubMutation();
const { userInfo } = useSelector((state) => state.auth);
console.log(userInfo);

const [currentPlan, setCurrentPlan] = useState(null);

const [gcemas, { isLoading: isLoading }] = useGetCecmasMutation();
const [admin, setAdmin] = useState(null);

const getMysub = async () => {
    try {
        const res = await getmySub().unwrap();
        setCurrentPlan(res.subscription);
        console.log(res.subscription);
    } catch (err) {
        console.log(err);
    }
    };

  
    const getmas = async () => {
        try {
            const res = await gcemas().unwrap();
            console.log(res);
            setAdmin(res.user);//true
            
        } catch (err) {
            console.log(err);
        }

    }

    useEffect(() => {
        getMysub();
        getmas();
    }, []);

  return (

    currentPlan != null && admin != null ? (
        userInfo && currentPlan.plan_id != "68a2df20b2bdf6c04cb5295b" && currentPlan.status == "active" || admin == true ? <Outlet /> : <Navigate to='/Subscription' replace /> 
     ):(
        <Card>
            Please wait redirecting... <Spin />
        </Card>
    )
  )
};

export default FreeRoute;
